import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { UserEffects } from './user.effect';
import { UserFacade } from './user.facade';
import { userReducer } from './user.reducer';
import { UserService } from './user.service';

@NgModule({
  imports: [
    StoreModule.forFeature('user', userReducer),
    EffectsModule.forFeature([
      UserEffects,
    ]),
  ],
  providers: [
    UserService,
    UserFacade
  ]
})
export class UserModule {}
